//
//
//
//
//

// import _ from 'underscore'

export default {
  props: {
    width: {
      default: 1000
    },
    height: {
      default: 500
    },
    value: {
      default: ''
    }
  },
  data: function () {
    return {
      id: `editor${Math.random().toString().slice(-10)}`,
      ue: undefined
    }
  },
  watch: {
    value: {
      handler (val) {
        // console.log('val', val)
        if (this.ue) {
          // console.log('this.ue', this.ue)
          let content = this.ue.getContent()
          // let content = this.ue.getAllHtml()
          // console.log('value', this.value)
          // console.log('content', content)
          if (content !== this.value) {
            this.ue.setContent(val)
          }
        }
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.ue = window.UE.getEditor(this.id)
      this.ue.ready(() => {
        // 设置编辑器的内容
        this.ue.setContent(this.value)
        this.$emit('ready', this.ue)
        this.ue.addListener('contentChange', () => {
          let content = this.ue.getContent()
          // let content = this.ue.getAllHtml()
          if (this.value !== content) {
            this.$emit('input', content)
          }
        })
        window.UE.getEditor(this.id).setHeight(this.height)
      })
    }, 300)
  },
  destroyed () {
    // console.log('uedit.destory()')
    this.ue.destroy()
  },
  methods: {
    getContent () {
      return this.ue.getContent()
      // return this.ue.getAllHtml()
    }
  }
}
